import { Loading } from "element-ui";
import { ElLoadingComponent } from "element-ui/types/loading";

export default class LoadingManager {
  static loadingNumber = 0;
  static loadingInstance: ElLoadingComponent;
  static timeout = 0;

  static showLoading() {
    if (LoadingManager.loadingNumber === 0) {
      clearTimeout(LoadingManager.timeout);
      LoadingManager.loadingInstance = Loading.service({
        background: "rgba(19,20,23, 0.2)",
      });
    }
    LoadingManager.loadingNumber++;
  }

  static hideLoading() {
    // 防止showLoading和hideLoading没有配对使用，导致loadingNumber被减成负数，再调用showLoading没有效果的问题
    LoadingManager.loadingNumber = Math.max(
      LoadingManager.loadingNumber - 1,
      0
    );
    if (LoadingManager.loadingNumber <= 0) {
      LoadingManager.timeout = window.setTimeout(() => {
        LoadingManager.loadingInstance &&
          LoadingManager.loadingInstance.close();
      }, 150);
    }
  }
}
